//

import DraftEditor from '@draft-js-plugins/editor';
import { Modifier, EditorState } from 'draft-js';
import { customStyleFn, blockStyleFn } from 'modules/common/utils';

import highlightDecoratorPlugin from './highlightPlugin';

import { filterState, shouldFilterOnPaste, getExtendedBlockRenderMap, sanitizePageBreaks } from './utils';
import { pluginsGroup, AlignmentTool } from './plugins';
import { ImageEntityWrapper } from './components';

import 'draft-js/dist/Draft.css';

const Editor = ({ element, editorState, setEditorState, onFocus }) => {
  const handleChange = (nextEditorState) => {
    let filteredEditorState = nextEditorState;
    const shouldFilterEmojis = shouldFilterOnPaste(editorState, nextEditorState);

    if (shouldFilterEmojis) {
      filteredEditorState = filterState(nextEditorState);
    }

    filteredEditorState = sanitizePageBreaks(filteredEditorState);
    setEditorState(filteredEditorState);
  };

  const handlePastedText = (text) => {
    const content = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const blockType = content.getBlockForKey(selection.getStartKey()).getType();

    if (blockType === 'page-break') {
      const newContent = Modifier.replaceText(content, selection, text);
      const newState = EditorState.push(editorState, newContent, 'insert-characters');
      const resetContent = Modifier.setBlockType(
        newState.getCurrentContent(),
        newState.getSelection(),
        'unstyled',
      );
      setEditorState(EditorState.push(newState, resetContent, 'change-block-type'));
      return 'handled';
    }

    return 'not-handled';
  };

  const extendedBlockRenderMap = getExtendedBlockRenderMap({
    atomic: {
      element: 'section',
      wrapper: <ImageEntityWrapper />,
    },
    'page-break': {
      element: 'aside',
    },
  });

  return (
    <div onClick={onFocus}>
      <DraftEditor
        onFocus={onFocus}
        onChange={handleChange}
        editorState={editorState}
        customStyleFn={customStyleFn}
        blockStyleFn={blockStyleFn}
        handlePastedText={handlePastedText}
        placeholder={element.placeholder}
        plugins={[...pluginsGroup, highlightDecoratorPlugin]}
        blockRenderMap={extendedBlockRenderMap}
        spellCheck
      />
      <AlignmentTool />
    </div>
  );
};

export default Editor;
